<template>
  <!-- eslint-disable max-len -->
  <div class="page-block">
    <header-bar v-if="isLoggedIn">ヘルプ</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">{{ isBtoC? 'サブスクリプション型音楽配信代行サービス [narasu]': '' }}利用規約</h3>
    </div>
    <div class="page-block__inner">
      <div
        v-if="isBtoB"
        class="terms-area">
        <div class="terms-text__box">
          <p>
            本サービスは、ユーザーと弊社との間で締結済みの音楽配信許諾基本契約書における音源ファイル等の格納（弊社への提供）を内容とするものであり、ユーザーと弊社との間には、本サービスの利用においても、以下に定める利用規約の他、音楽配信許諾契約書の規定が適用されます。
            <br />（※具体的な手続き及びフローをテストページ確認後、追記します。）
          </p>
        </div>
        <h4>第１条：パスワードおよびアカウント情報の管理</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>ユーザーは、自己の責任において、本サービスに関するアカウント情報およびパスワード(以下｢アカウント等｣と総称します)を適切に管理するものとし、これを第三者に利用させ、または譲渡、貸与、名義変更等をしてはならないものとします。</li>
            <li>アカウント等の管理不十分、使用上の過誤、第三者の使用等によって生じた損害に関する責任はユーザーが負うものとし、当社は一切責任を負いません。</li>
            <li>当社は、入力されたアカウント等が登録されたものと一致することを当社所定の方法により確認した場合、当該アカウント等を入力した者による本サービスの利用を正当なユーザーによるものとみなします。アカウント等の盗用、不正使用その他の事情により、正当なユーザー以外の第三者による不正な利用があっても、これに起因してユーザーに生じた損害につき、当社は一切責任を負わないものとします。</li>
            <li>ユーザーは、アカウント等を紛失・遺漏した場合またはそのおそれがある場合には、速やかに当社にその旨通知し、当社の指示に従った措置をとらなければならないものとします。</li>
          </ol>
          <p>{{ appName === 'Zu-MAP'?'ZULA(ズーラ)':appName }}では、ご利用になるお客様のプライバシー及び個人情報の保護にあたり、適用される法令及びその他の規範を遵守いたします。</p>
        </div>
        <h4>第２条：知的財産権</h4>
        <div class="terms-text__box">
          <p>本サイトに含まれる文章・画像・映像・サイトデザイン・レイアウト・商標・標章その他一切の情報の知的財産権は当社または当社にその利用を許諾した権利者に帰属しています。ユーザーはこれらの情報を当社の事前の許諾なく利用または使用することはできません。</p>
        </div>
        <h4>第３条：禁止事項</h4>
        <div class="terms-text__box">
          <p>ユーザーは、本サービスの利用にあたり、次の各号に掲げる行為またはそのおそれのあると当社が判断する行為を行ってはならないものとします。</p>
          <ol class="numbered">
            <li>法令または本規約に違反する行為、犯罪行為に関連する行為または公序良俗に反する行為</li>
            <li>当社または出店者その他の第三者の財産権(知的財産権を含む)、人格権(名誉権、肖像権、プライバシーの権利)その他の権利を侵害し、または信用を毀損する行為</li>
            <li>第三者への成りすまし、または配信登録の際に虚偽の情報を申告する行為</li>
            <li>有害なコンピュータプログラム、メール等を送信し、または書き込む行為</li>
            <li>本サービスの提供に用いられているサーバその他当社のコンピュータに過度な負荷をかけ、または不正にアクセスする行為</li>
            <li>本サービスの運営・維持を妨げる行為</li>
            <li>前各号のほか、当社が不適当と判断する行為</li>
          </ol>
        </div>
        <h4>第４条：利用拒絶等</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>当社は、ユーザーが次の各号のいずれかに該当する場合には、当該ユーザーによる本サイトへのアクセスまたは本サービスの利用を拒絶するために必要な措置を講じ、または当該ユーザーの会員登録を抹消することができるものとします。この場合、当社は、当該ユーザーに対し、当該措置を講じた理由を開示する義務を負いません。</li>
            <ul>
              <li>(1)本規約のいずれかの規定に違反し、または違反するおそれがあると当社が合理的に判断したとき、もしくは過去に違反したことがあるとき</li>
              <li>(2)当社に提供した情報(登録情報を含みます)が虚偽であることが判明した場合</li>
              <li>(3)アカウント等を不正に使用し、または第三者に使用させた場合</li>
              <li>(4)一定回数以上のアカウント等の入力ミスがあり、セキュリティの観点から必要であると当社が認めた場合</li>
              <li>(5)暴力団、暴力団員、暴力団関係団体、暴力団関係者、その他の反社会的勢力(以下あわせて｢暴力団等｣という)であることが判明したとき、または過去に暴力団等であったことが判明したとき</li>
              <li>(6)破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始もしくはこれらに類する手続の開始の申立てを自ら行い、もしくは第三者からなされた場合</li>
              <li>(7)当社から連絡が取れなくなった場合</li>
              <li>(8)前各号のほか、当社が本サイトへのアクセスまたは本サービスの利用を不適当と判断したとき</li>
            </ul>
            <li>前項各号のいずれかの事由に該当した場合、ユーザーは、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちにすべての債務の支払を行わなければなりません。</li>
            <li>当社は、本条に基づき当社が行った措置によりユーザーに生じた損害について、一切の責任を負いません。</li>
          </ol>
        </div>
        <h4>第５条：本サービスの一時停止</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>当社は、本サービスを常に良好な状態でご利用いただくため、次の各号に掲げる場合には、ユーザーに対する事前の通知その他何らの手続を要することなく、本サービスの全部または一部の提供を一定期間停止することができるものとします。</li>
            <ul>
              <li>(1)本サービスの提供に用いられているサーバ、ソフトウェア等の点検、保守、修理、修補、改良等(定期であると緊急であるとを問いません)に必要があるとき</li>
              <li>(2)本サービスの提供に用いられているサーバ、ソフトウェア等のトラブル、電源供給の停止、ネットワークトラブル等が生じたとき</li>
              <li>(3)システムに負荷が集中した場合等、本サービスの正常な提供に支障が生じると当社が合理的に判断したとき</li>
              <li>(4)その他、運用上ないし技術上必要であると当社が判断したとき</li>
            </ul>
            <li>当社は、当社に故意または重過失がある場合を除き、前項に基づく当社の措置に起因してユーザーに生じた損害について、なんらの責任を負いません。</li>
          </ol>
        </div>
        <h4>第６条：本サービスの変更、廃止</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>当社は、その裁量で本サービスの内容を変更し、または本サービスの全部または一部の提供を廃止することができるものとします。</li>
            <li>当社は、前項に基づく当社の措置に起因してユーザーに生じた損害について、一切の責任を負いません。</li>
          </ol>
        </div>
        <h4>第７条：無保証</h4>
        <div class="terms-text__box">
          <p>当社は、本サービスの提供に障害が生じないこと、本サイトの利用に関連して送信される電子メール、ウェブコンテンツ等に、コンピュータウィルス等の有害なものが含まれていないことを保証するものではありません。</p>
        </div>
        <h4>第８条：不可抗力</h4>
        <div class="terms-text__box">
          <p>停電・通信回線の事故・天災等の不可抗力、通信事業者の不履行、インターネット通信回線の不具合、サーバ等のシステム上の不具合または緊急メンテナンスの発生その他甲の責に帰すことのできない事由により、サーバまたはソフトウェアの障害・不具合・誤動作、本サービスの全部または一部の停止等の事態が発生した場合であっても、これに起因してユーザーに生じた損害等につき、当社はなんらの責任を負いません。</p>
        </div>
        <div class="c-btn-wrap">
          <router-link
            :to="{ name: 'index' }"
            class="c-btn c-btn--back">
            トップへ戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </router-link>
        </div>
      </div>
      <div
        v-else
        class="terms-area">
        <div class="terms-text__box">
          <p>
            本サブスクリプション型音楽配信代行サービス [narasu]利用規約（以下「本利用規約」といいます。）は、株式会社ローディアムが提供するサブスクリプション型音楽配信代行サービスの利用に関する諸条件を定めるものです。本サービス（第1条で定義します。）の利用を希望される方は、本利用規約をよくお読み頂き、全てに同意の上ご利用下さい。本サービスを利用された場合、本利用規約の全ての記載内容に承諾したものとみなされます。本利用規約に同意いただけない場合、本サービスを利用することはできません。<br />
            18歳未満の方は、親権者等の法定代理人の同意が必要となります。なお、アカウント管理者が18歳未満の場合、本サービスを利用した時点で、親権者等の法定代理人の同意が得られているものとみなします。
            <br /><br />
            本サービスのご利用に際しては、本利用規約及び当社が別途定める配信規定その他の規定が適用されます。なお、配信規定その他の規定については、本利用規約の一部を構成しますので、当社ウェブサイトに掲載される本利用規約及び配信規定その他の規定の最新版を随時ご確認ください。本利用規約と配信規定その他の規定が異なる場合は、配信規定その他の規定が優先して適用されるものとします。
          </p>
        </div>
        <h4>第１条：定義</h4>
        <div class="terms-text__box">
          <ol class="terms-list numbered">
            <li>「当社」とは、株式会社ローディアムをいいます。</li>
            <li>「本サービス」とは、アーティストのコンテンツについて当社が本利用規約の条件に従って提供する配信ストアへの音楽配信ライセンスの受託サービスをいいます。</li>
            <li>「アカウント」とは、本サービスを利用するために必要な仮想口座「narasuアカウント」をいいます。アカウントは、アカウント管理者ごとに開設され、販売収益（第6条に定義）その他アカウント管理者等が受領権限を有する金額をプラス計上し、利用料その他当社が収受すべき金額をマイナス計上します。なお、アカウントの残高には利息はつきません。</li>
            <li>「アカウント管理者」とは、本利用規約に同意の上、本サービスへの登録の申込をされた方であって、当社が当該申込を承諾した方をいいます。なお、本サービス上において、「管理者」と表記する場合があります。</li>
            <li>「アカウントメンバー」とは、アカウント管理者により本サービスの利用の招待を受け、本利用規約に同意の上、本サービスへの登録の申込をされた方であって、当社が当該申込を承諾した方をいい、当該アカウント管理者に開設されたアカウントに紐づけられる方をいいます。なお、本サービス上において、「ゲスト」と表記する場合があります。</li>
            <li>「アカウント管理者等」とは、アカウント管理者とアカウントメンバーの総称をいいます。</li>
            <li>「アーティスト」とは、本サービスの対象となるコンテンツの著作権者その他、本サービスによる配信を許諾する正当な権利者をいいます。</li>
            <li>「配信ストア」とは、当社と契約を締結した又は将来締結する、音楽のオンライン配信事業者及び、歌詞の配信その他の利用（楽曲との同期・非同期を問わない）を行う事業者が管理運営する配信サービスサイトをいいます。</li>
            <li>「コンテンツ」とは、楽曲・歌詞およびその録音物や録画物（ミュージックビデオ等の映像）・楽曲名・カバーアート・アーティスト写真・その他、アカウント管理者が本サービスに登録または提供（アップロードを含む）した情報等をいいます。</li>
          </ol>
        </div>
        <h4>第２条：本サービス</h4>
        <div class="terms-text__box">
          <ol class="terms-list numbered">
            <li>本サービスの一環として、アカウント管理者は自身の管理画面において各配信ストアにおける販売実績等のレポートや販売収益を確認することができます。</li>
            <li>本サービスは、日本語を十分に理解し読み書きができる、日本国内在住の個人又は日本国内に事業拠点を有する法人を対象とします。</li>
            <li>
              アカウント管理者等は、以下の事項を表明・保証します。本サービスの提供は、これらの表明・保証が全て正確かつ真実であること、及びアカウント管理者等が本利用規約を遵守することを条件とします。
              <ol>
                <li>(1) アカウント管理者等が、本サービスの登録・利用を行うために必要なかつ完全な権利及び権限を有すること。</li>
                <li>(2) アカウント管理者等が、日本国内在住の個人又は日本国内に事業拠点を有する法人であること。</li>
                <li>(3) 本利用規約に従ったアカウント管理者等による本サービスの登録・利用（支払の受領、及び利用の停止・中止を含みます。以下本条において同じです）、並びに、本サービスに係るコンテンツの利用（当社及び配信ストア、並びにそれらの者のライセンシー及び利用者による利用を含みます。以下本条において同じです）が、法令及びアカウント管理者等と第三者とのいかなる契約その他の合意にも抵触せず、違反又は債務不履行を構成しないこと。</li>
                <li>(4) アカウント管理者とアーティストが同一でない場合（アカウント管理者と同一であるアーティスト以外にアーティストが存在する場合を含みます。）、アカウント管理者は全てのアーティストから、本利用規約に従ったアカウント管理者による本サービスの登録・利用、並びに本サービスに係るコンテンツの利用に必要な一切の授権を取得済みであること。</li>
                <li>(5) アカウント管理者等が本利用規約に基づき、または本サービスに関連して提供する情報は、全て正確であること。</li>
              </ol>
            </li>
            <li>
              第3条（アカウント登録）及び第4条（アーティスト登録/コンテンツのリリース登録）に従い、アカウント登録・アーティスト登録・コンテンツの登録をおこなった上で、当社所定のアカウント情報、アーティスト情報およびコンテンツ情報を当社に提供し、利用料を支払い、当社の審査及び承認を受けることにより、アカウント管理者は以下を当社に許諾及び委託するものとし、当社は本利用規約により許諾を受けた事項を、第三者に再許諾（再々許諾以降も含みます。）することができるものとします。
              <ol>
                <li>
                  (1) アーティストのコンテンツにつき、各配信ストアの配信形態に合わせて、各配信ストアからの配信を許諾し、かかる配信に必要なコンテンツデータ等を当該配信ストアに提供すること。ただし、配信形態は主に以下のものになりますが、これらに限られません。
                  <ul>
                    <li>① ダウンロード配信</li>
                    <li>② ストリーミング配信（インタラクティブ/ノンインタラクティブ）</li>
                    <li>③ クラウドサービスによる配信</li>
                    <li>④ 映像とのシンクロ配信</li>
                    <li>⑤ 歌詞の配信その他の利用（楽曲との同期・非同期を問わない）</li>
                  </ul>
                </li>
                <li>(2) 当社が必要と判断した場合、各配信ストアの配信形態及び配信条件に合わせてアーティストのコンテンツに加工等を行うこと。</li>
                <li>(3) 各配信ストアより、アーティストのコンテンツの販売収益を回収すること。</li>
                <li>(4) 各配信ストアより、アーティストのコンテンツの販売実績等のレポートの提供を受けること。</li>
              </ol>
            </li>
            <li>当社は、当社の判断で配信ストアおよび配信形態を選択し、新たな配信ストアとの契約又は現在契約を締結している配信ストアとの契約解除を行うことができます。アカウント管理者はこれに一切異議を述べないものとします。アカウント管理者は、アーティストのコンテンツが配信ストアの配信条件に合致しない場合はその配信ストアにおいて、配信ができない又は配信が停止されることを了承するものとします。</li>
          </ol>
        </div>
        <h4>第３条：アカウント登録</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>本サービスの利用を希望される方は、当社所定の方法によりアカウント登録の申込をおこなった上で、当社所定のアカウント情報（アカウント管理者の氏名・住所・連絡先を含むが、これらに限られません。）を提供するものとします。当社は、当社が必要と判断した場合、申込書、本人確認書類その他追加書類の提出を求めることができるものとし、当該申込者はこれに従うものとします。</li>
            <li>
              当社は、以下のいずれかの事由に該当する場合、登録申込を承認しないことができ、またその理由について一切開示義務を負いません。
              <ol>
                <li>(1) 過去に何らかの事由により、アカウントを抹消された方による申込</li>
                <li>(2) 既にアカウントをお持ちの方による申込</li>
                <li>(3) 申込内容に虚偽の事項（他人名義や存在しない名義での申請を含みます。）が含まれている場合</li>
                <li>(4) アカウントの名義と登録口座の名義が一致しない場合</li>
                <li>(5) 登録口座が過去において抹消されたアカウントにおいて登録されていた場合</li>
                <li>(6) 入力したメールアドレスに当社から電子メールの送信ができない場合</li>
                <li>(7) 未成年者、成年被後見人、被保佐人又は被補助人のいずれかによる申込であり、法定代理人、後見人､保佐人または補助人の同意等を得ていない場合</li>
                <li>(8) 申込者が反社会的勢力（暴力団、暴力団員、暴力団員でなくなったときから5 年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋、その他暴力、威力または詐欺的手法を使用して経済的利益を追求する集団または個人をいいます。以下同じです。）に該当する場合、又は反社会的勢力と何らかの関係を有していると当社が判断した場合</li>
                <li>(9) 当社が求める本人確認書類その他追加書類の提出に応じない場合</li>
                <li>(10) 提出された本人確認書類その他追加書類に虚偽、不正確、不備又は改ざんがあると当社が判断した場合</li>
                <li>(11) その他当社が不適当と判断した場合</li>
              </ol>
            </li>
            <li>当社は、アカウント登録の申込を承認する場合、アカウントを発行するものとします。アカウントの発行をもって、当社が当該承認をしたものとみなします。</li>
            <li>アカウント管理者等は、当社に届け出ている事項に変更が生じた場合には、当社が指定する方法により、すみやかに届け出るものとします。当社は、アカウント管理者等が届出をしなかったことにより不利益を被った場合、一切の責任を負いません。</li>
            <li>アカウント管理者等は、アカウントID及びパスワードを自らの責任のもとに厳重に管理するものとし、その使用及び管理について一切の責任を負うものとします。当社は、アカウント管理者等のアカウントID及びパスワードが第三者により不正に使用された場合等であっても、当社の故意・重過失によるものを除き、アカウント管理者等自身の適正な利用とみなし一切の責任を負いません。</li>
            <li>アカウント管理者等がアカウントの削除を希望する場合、当社が指定する方法により手続を行うものとします。</li>
            <li>当社は、2年間ログインが行われていないアカウントを抹消することができるものとします。この場合、アカウント管理者等は、当該アカウント残高が支払われないことを了承するものとします。</li>
            <li>アカウントが削除または抹消された場合、その時点以降、当社は本サービスを提供する義務を負いません。</li>
          </ol>
        </div>
        <h4>第４条：アーティスト登録/コンテンツのリリース登録</h4>
        <div class="terms-text__box">
          <ol class="terms-list numbered">
            <li>アカウント管理者は、前条に基づくアカウント登録をおこなった上で、本サービスの対象とすることを希望するコンテンツにつき、当社所定のフォームよりアーティスト登録及びコンテンツのリリース登録を行い、当社所定の支払方法（クレジットカード決済・キャリア決済）から選択し、利用料の決済を行うものとします。その上で、当社の審査を経て承認された場合にのみ、当該コンテンツは本サービスを通じて配信されます（その場合、当社からアカウント管理者に対し、配信手続開始通知を電子メールで送付します。）。なお、いかなる理由でもコンテンツの配信手続開始後に配信をキャンセルすることは出来ません。また、当社の承認後は、利用料の返金は出来ません。</li>
            <li>アカウント管理者は、コンテンツの内容が各配信ストアの配信条件に合致しない場合、その他当社が不適当と判断した場合に、当社が当該コンテンツの配信を承認せず、または登録および配信を拒絶できることを了承するものとします。</li>
            <li>アカウント管理者は、第1項に従いリリース登録された各コンテンツにつき、本サービス利用の対価として、当社が定める利用料を支払います。利用料は、当社所定の支払方法（クレジットカード決済・キャリア決済）により決済を行うものとします（キャリア決済の場合は、利用料の他、事務手数料がかかります。）。詳細は、当社が別途定める配信規定によるものとします。</li>
            <li>アカウント管理者は、クレジットカード決済・キャリア決済に関してアカウント管理者本人名義のクレジットカードまたはアカウント管理者が契約しているキャリアIDを使用することとします。これに違反した場合は当社が当該コンテンツの配信を承認せず、または登録および配信を拒絶できることを了承するものとします。</li>
            <li>配信停止を行うことは原則として出来ません。ただし、止むを得ない事情がある場合、配信停止を希望する旨の電子メールを当社宛に送り、当社の指示に従うものとします。</li>
          </ol>
        </div>
        <h4>第５条：コンテンツについて</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>アカウント管理者は、当社及び当社から許諾された第三者が本サービスの提供に関連して（配信サイトにおける利用並びにコンテンツの販売促進及び本サービスの広告宣伝を含みます。）、コンテンツに含まれる情報等を無償で使用することを許諾するものとします。ただし、当社がコンテンツの販売促進活動を行う義務を負うものではありません。</li>
            <li>当社は、コンテンツの販売促進のために各配信ストアにおいて、コンテンツを各配信ストアの利用者に無償で試聴させることができるものとします。</li>
            <li>アカウント管理者は、コンテンツに関する著作者人格権を保有するものをして、当社及び当社から許諾された第三者に対して著作者人格権を行使させないものとします。</li>
            <li>
              アカウント管理者は、登録または提供するコンテンツに関し、当社に対し以下を保証するものとします。但し、著作権管理事業者（第6条（販売収益等）に定義）に管理委託されている音楽著作物について、当該事業者やその受託事業者の規程に基づく利用許諾の申請・取得及び著作権使用料の支払を、配信ストアが所定条件に従って行う場合は除きます。
              <ol>
                <li>(1) コンテンツに関する著作権・著作隣接権・肖像権その他一切の権利について、正当な権利者であること、又は、正当な権利者から本サービスに係るコンテンツの利用（当社及び配信ストア、並びにそれらの者のライセンシー及び利用者による利用を含む。以下本条において同じ）に必要な一切の許諾を受けていること。</li>
                <li>(2) 本サービスに係るコンテンツの利用が、第三者の著作権・著作隣接権・肖像権その他一切の権利を侵害しないこと。</li>
              </ol>
            </li>
            <li>アカウント管理者は、コンテンツに関して当社または配信ストアに対して第三者から異議・苦情等の申立又は損害賠償等の請求があった場合には、自らの責任と費用負担において処理するものとし、当社に一切損害を発生させないものとします。また、この場合、当社は、当該紛争が解決し、または、解決する見込みが高いと当社が判断するまでの間、当該アカウント（これに関連すると当社が判断したアカウントを含む。）による本サービスの利用停止、中止、利用契約の解除その他必要と認める措置をとることができるものとします。</li>
            <li>アカウント管理者等は、本サービスを利用したことに起因して（当社がかかる利用を原因とするクレームを第三者より受けた場合を含みます。）、当社が直接的または間接的に何らかの損害（弁護士費用の負担を含みます。）を被った場合、当社の請求に従って直ちにこれを賠償しなければなりません。</li>
            <li>
              アカウント管理者は、以下の内容を含むコンテンツを登録または提供（アップロードを含む）してはならないものとします。
              <ol>
                <li>(1) 第三者の有する著作権・著作隣接権・肖像権・その他の権利を侵害する又はそのおそれのあるもの</li>
                <li>(2) 犯罪行為、違法行為を肯定する内容を含むもの</li>
                <li>(3) 公序良俗に反する又はそのおそれがあるもの</li>
                <li>(4) 差別的表現、未成年者にとって有害と認められる情報を含むもの</li>
                <li>(5) その他当社が不適切と判断するもの</li>
              </ol>
            </li>
            <li>アカウント管理者等は、本サービスを、当該サービスを通じたアーティストのコンテンツの配信販売の目的のみに利用するものとし、それ以外の目的（当社以外による同種または類似サービスの開発・検討等を含みます）に本サービス（当該サービスを通じて得られるデータ、ノウハウ等を含みます）を利用することは禁止されています。また、本サービス利用期間中及びその後1年間、本サービスと競合するサービスの開発・従事・利用等を行うことも禁止されます。これらの禁止行為を行った場合は本規約違反となり、当社は直ちに当該サービスまたはアカウントの利用停止・中止、当該サービスの利用契約の解除その他必要と認める措置をとることができるものとします。また、かかる措置は当社による損害賠償請求を妨げないものとします。</li>
          </ol>
        </div>
        <h4>第６条：販売収益等</h4>
        <div class="terms-text__box">
          <ol class="terms-list numbered">
            <li>「販売収益」とは、本利用規約において、当社がコンテンツの配信許諾の対価として、各配信ストアから実際に支払いを受けた金額から、当該金額に対し所定の料率を乗じた金額を差し引いた後の金額をいいます。詳細は、当社が別途定める配信規定によるものとします。なお、当社はかかる対価が配信ストアから任意に支払われない場合、これを取立あるいは回収する義務を負わないものとします。</li>
            <li>当社は、各配信ストアからの販売収益をアカウントに計上のうえ、当社所定の方法によるアカウント管理者等からの支払要請があるまで当社の口座で保管することとし、アカウント管理者等は当社が保管するこの販売収益に利子やその他配当等がつかないことを了承することとします。なお、販売収益に1円未満の端数がある場合、当社はアカウントに計上しないことができます。</li>
            <li>
              著作権使用料について
              <ol>
                <li>
                  (1) コンテンツの著作権管理を、一般社団法人日本音楽著作権協会その他の著作権等管理事業者（以下「著作権管理事業者」といいます。）に委託している場合
                  <ol>
                    <li>① アカウント管理者はコンテンツの登録時に、著作権管理事業者名やID等の必要な情報を、当社所定の方法で登録するものとします。登録した情報の不備等に起因する損額（権利者に著作権使用料が支払われなかった等）について当社は一切の責任を負いません。</li>
                    <li>② 著作権使用料の支払については、第5条（コンテンツについて）第4項参照。なお、使用料の額は、著作権管理事業者と各配信ストアとの間で定められた金額とし、アカウント管理者はこれを了承するものとします。</li>
                  </ol>
                </li>
                <li>
                  (2) コンテンツの著作権管理を、著作権管理事業者に委託していない場合<br />
                  アカウント管理者は、当社が定める一部の地域/配信ストアにおいて販売されたコンテンツに関する著作権使用料を除き、原則としてコンテンツに関する著作権使用料が支払われず、また、配信ストアの運用に応じて販売収益が減額される場合があることを了承するものとします。詳細は、当社が別途定める配信規定によるものとします。
                </li>
                <li>(3) アカウント管理者は、各配信ストアの無償試聴について、コンテンツに関する著作権使用料が支払われないことを了承するものとします。</li>
              </ol>
            </li>
            <li>アカウント管理者は、当該アカウントに関してアカウントメンバーが存在する場合、当社所定の方法により、アカウント管理者とアカウントメンバーとの間における販売収益の配分率を設定することができます。</li>
            <li>アカウント管理者（アカウント管理者が前項の規定に基づき配分率を設定した場合は、本条において以下アカウントメンバーを含みます。）は当社に対し、当社所定の方法により、販売収益の支払要請をすることができます。</li>
            <li>当社は、当社がアカウント管理者の支払要請（ただし、支払前の残高が当社所定の基準額を上回る場合に限ります。）を確認後1ヶ月以内に、アカウント残高の内、アカウント管理者が指定した金額を、アカウント管理者が当社所定の方法であらかじめ登録した銀行口座に振り込む方法により支払うものとします。なお、振込に必要な銀行手数料は、アカウント管理者が負担するものとします。また、登録された口座情報の不備により当社が振込をできなかった場合、銀行の組み戻し費用はアカウント管理者が負担するものとします。</li>
            <li>アカウント管理者は、各配信ストアにおいて、販売したコンテンツの返品等が当社または各配信ストアの判断により行われる場合があることを了承するものとします。この場合、当社は、アカウント管理者のアカウント残高から返品額を差し引くものとし、アカウント管理者はこれを了承するものとします。</li>
            <li>アカウント管理者が支払を受けた販売収益等は、アカウント管理者の責任と負担において、アーティストその他の正当な権利者へ配分するものとします。当社は、アカウント管理者に支払った後の販売収益等の配分について一切の責任を負いません。</li>
          </ol>
        </div>
        <h4>第７条：禁止事項</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>
              アカウント管理者等は以下の行為を行なってはならないものとします。
              <ol>
                <li>(1) 本利用規約に違反する行為</li>
                <li>(2) 法令、条例等に違反する行為</li>
                <li>(3) 公序良俗に反する行為</li>
                <li>(4) 当社もしくは第三者の著作権・著作隣接権・肖像権、商標権その他一切の権利を侵害する行為又は侵害するおそれのある行為</li>
                <li>(5) 当社もしくは第三者の権利、利益、名誉、信用等を損ねる行為</li>
                <li>(6) 当社もしくは第三者の名称を無断で使用するなどして当社もしくは第三者になりすます行為</li>
                <li>(7) 第三者が権利を有する楽曲を権利者に無断で登録又は提供（アップロードを含む）する行為</li>
                <li>(8) 不正な方法により楽曲又は動画の再生回数を増やす行為（これに類する行為を含む）</li>
                <li>(9) 機械的なプログラムを用いて短時間に大量に楽曲を登録する行為</li>
                <li>(10) 生成AIを不当に利用した楽曲を登録又は提供（アップロードを含む）する行為</li>
                <li>(11) 第三者の個人情報を収集する行為</li>
                <li>(12) 政治団体、宗教団体への勧誘行為</li>
                <li>(13) リバースエンジニアリング、その他本サービスのソースコード、構造等を解析する行為</li>
                <li>(14) 本サービスのサーバーその他設備への不正アクセス、スパムメールの送信等、本サービスの提供を妨げる行為</li>
                <li>(15) 前各号の行為を試みること</li>
                <li>(16) 虚偽、不正確、不完全又は改ざんされた本人確認書類その他資料を提出する行為</li>
                <li>(17) 当社による本人確認、権利確認、不正利用調査その他本サービスの適正な運営のために必要な調査を拒否し、又は妨害する行為</li>
                <li>(18) その他当社が不適切と判断する行為</li>
              </ol>
            </li>
            <li>
              アカウント管理者は、以下のコンテンツを本サービスの対象として登録又は提供（アップロードを含む）してはならないものとします。
              <ol>
                <li>(1) 第三者の著作権・著作隣接権・肖像権、商標権その他一切の権利を侵害しているコンテンツ</li>
                <li>(2) 生成AIを用いて不適切な方法で作成したコンテンツ </li>
                <li>(3) 音源の長さが10分以上のコンテンツ</li>
              </ol>
            </li>
            <li>アカウント管理者等が前二項のいずれかに違反し、もしくはアカウント管理者等が第3条（アカウント登録）第2項所定の事由に該当することが判明し、又はそれらのおそれがある行為（以下「違反行為」という。）があったものと当社が判断した場合（配信ストアから違反行為があった旨当社が通知を受けた場合を含みます。）、当社は、事前にアカウント管理者等に通知することなくアカウント管理者等のアカウントの凍結（その場合、アカウントの残高支払要請及び削除ができなくなります。）、抹消、第6条（販売収益等）第2項に基づきアカウントに計上した販売収益の全部又は一部の減額その他当社が適切と判断する措置をとることができるものとします。なお、当該アカウントの一部のコンテンツに関して違反行為が認められた場合であっても、当該アカウントまたはこれに関連するアカウントの全てのコンテンツに対して当該措置を行うことができます。</li>
            <li>当社は、前項の措置によりアカウント管理者等又はアーティストが被った損害について一切の責任を負いません。</li>
            <li>本条に定める事項について、当社が事実関係の確認のための調査が必要と判断した場合、当社は、本人確認書類、権利関係を確認できる資料その他当社が必要と判断する資料の提出を求めるなど、必要な調査を行うことができるものとし、アカウント管理者等はこれに協力するものとします。アカウント管理者等が当該調査に協力しない場合、当社は、当該アカウント又はこれに関連すると当社が判断したアカウントについて、利用停止、アカウント凍結、配信停止、販売収益の支払停止その他当社が適切と判断する措置を講じることができるものとします。</li>
            <li>アカウント管理者等は、違反行為により当社又は第三者が被った損害（弁護士費用その他解決に要した費用や、当社が配信ストアから請求された違約金その他一切の損害を含む。）について賠償するものとします。なお、この場合、当社は、第3項に定める措置として、第6条（販売収益等）第2項に基づきアカウントに計上した販売収益から、当該損害相当額を控除し、またはアカウント管理者等に対し、その賠償を請求することができるものとし、アカウント管理者等はこれを異議なく了承し、または異議なく対応するものとします（当該賠償請求への対応方法には、アカウント管理者等が当社に対し届出たクレジットカードによる当社所定の手続に従った引き落としを含みます。）</li>
          </ol>
        </div>
        <h4>第８条：本サービスの中止、停止</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>
              当社は、以下のいずれかの事由が発生した場合には、本サービスの全部又は一部の提供を停止することができるものとします。その場合、当社の裁量によりアカウントを凍結することができます。
              <ol>
                <li>(1) 設備等のメンテナンスを行う場合</li>
                <li>(2) 天災地変等の不可抗力の場合</li>
                <li>(3) 通信回線の障害等の事故があった場合</li>
                <li>(4) 法令等により本サービスの提供ができない場合</li>
                <li>(5) その他当社が必要と判断した場合</li>
              </ol>
            </li>
            <li>当社は、原則として3ヶ月前までにアカウント管理者等に通知することにより、本サービスの提供を中止することができるものとします。その場合、当社の裁量によりアカウントを抹消することができます。</li>
            <li>当社は、本サービスの全部/一部の提供の停止又は中止に起因してアカウント管理者等やアーティストが被った損害について、一切の責任を負いません。</li>
          </ol>
        </div>
        <h4>第9条：アカウントの抹消・凍結</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>
              当社は、アカウント管理者等に下記の事由が生じた場合（なお、アカウント管理者等が複数存在する場合、その一部について当該事由が生じた場合も含みます。）、何等の通知・催告なしにアカウントを抹消または凍結することができるものとします。
              <ol>
                <li>(1) 破産、民事再生、会社更生もしくは特別清算の手続が開始し、またはその申立て（本人による申立て準備を含む）があった場合</li>
                <li>(2) 解散または清算を決議した場合</li>
                <li>(3) 支払を停止し、または手形交換所の取引停止処分を受けた場合</li>
                <li>(4) 仮差押、差押もしくは競売の申立てを受けた場合</li>
                <li>(5) 租税公課を滞納し督促を受け、または保全差押を受けた場合</li>
                <li>(6) 監督官庁から営業停止などの処分を受けた場合</li>
                <li>(7) その他、当社が本サービスを継続しがたい事情があると認めた場合</li>
              </ol>
            </li>
            <li>当社は、前項各号の事由が生じた場合、本サービスの全部又は一部の提供を中止・停止することもできるものとします。</li>
            <li>当社は、前各項の措置に起因してアカウント管理者等やアーティストが被った損害について、一切の責任を負いません。</li>
          </ol>
        </div>
        <h4>第10条：通知・連絡</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>当社がアカウント管理者等に対して通知・連絡を行う場合、アカウント管理者等が当社所定の方法で当社に届け出たアドレス宛ての電子メールの送付をもってアカウント管理者等は当該通知・連絡を受領したものとみなします。</li>
          </ol>
        </div>
        <h4>第11条：業務の委託</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>当社は、本サービスの一部を当社が選定した第三者に委託することができるものとします。</li>
          </ol>
        </div>
        <h4>第12条：権利の帰属</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>本サービスにおいて当社が提供する著作物、素材、情報等に関する著作権その他一切の権利は、当社又は権利を有する第三者に帰属するものとします。アカウント管理者は、これらの権利を侵害する行為（無断複製、改変、頒布、配信等を含みます）を行うことができません。</li>
          </ol>
        </div>
        <h4>第13条：機密情報</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>アカウント管理者は、本サービスの利用にあたり知り得た当社又は第三者の技術上・業務上の機密を本サービス利用の目的外に使用してはならず、当社の書面による事前同意がない限り第三者に開示・漏洩してはならないものとします。</li>
          </ol>
        </div>
        <h4>第14条：免責・不保証</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>当社は、本サービス内に、欠陥・バグ・不具合その他の瑕疵がないこと、コンピューターウィルス等の破壊的構成物が含まれないことを保証しないものとします。</li>
            <li>当社は、本サービスにおいて当社が提供する情報等について、その正確性、信頼性、完全性、適法性、有効性、目的適合性等を保証しないものとします。</li>
            <li>当社は、アカウント管理者等が本サービスの利用又は利用できなかったことにより、アカウント管理者等又はアーティストが被った損害について、当社の故意・重過失によるものを除き、一切の責任を負わないものとします。</li>
            <li>本サービスに関連して当社がアカウント管理者等及びアーティストに対して負担する責任は、事由の如何を問わず、責任原因の発生前1年間において当社が現実に支払を受けた、当該アカウント管理者等、アーティスト及びコンテンツに係る本サービス提供の対価（念のため、アカウント管理者に支払われるべき対価を含みません。）の総額を上限とします。</li>
          </ol>
        </div>
        <h4>第15条：個人情報</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>当社は、アカウント管理者等が本サービスの利用に際して提供した個人情報を、個人情報保護法及び当社のプライバシーポリシーに従い取り扱うものとします。</li>
            <li>
              当社は、本サービスの提供により取得した個人情報を以下の目的で利用致します。
              <ol>
                <li>(1) コンテンツの配信</li>
                <li>(2) コンテンツの販売収益の回収及び分配</li>
                <li>(3) アカウント管理者等への連絡（利用料等の請求及び徴収を含む）</li>
                <li>(4) コンテンツの販売促進</li>
                <li>(5) 本サービスの広告宣伝活動</li>
                <li>(6) 本サービスに関するメールマガジン、ニュースその他の案内、アンケート、お問い合わせ対応</li>
                <li>(7) 統計資料の作成</li>
                <li>(8) 本人確認、不正利用、不正収益化、なりすまし、権利侵害その他不適切な行為の防止、調査及び対応</li>
                <li>(9) 利用規約違反への対応、アカウント停止、配信停止、販売収益の支払停止その他本サービスの適正な運営に必要な対応</li>
              </ol>
            </li>
            <li>
              当社では、本サービスの提供に必要な業務を外部事業者に委託することがあります。委託業務には、例えば以下のものがあります。
              <ol>
                <li>(1) 本サービスの利用料等の決済業務</li>
                <li>(2) 本サービスの保守・メンテナンス業務</li>
                <li>(3) 本サービスのサーバー管理業務</li>
              </ol>
            </li>
            <li>当社は、本サービスの提供に際し、コンテンツのプロモーション、営業、販売その他の目的で、レコード会社、VOCALOID™会社その他の者に、登録されたアーティスト名等の情報を提供する場合があります。</li>
            <li>当社は、本サービスの適正な運営、不正利用の防止、本人確認その他必要な範囲において、アカウント管理者等に対し、運転免許証、マイナンバーカード、健康保険証、在留カード、パスポートその他当社が指定する本人確認書類の提出を求めることがあります。</li>
            <li>アカウント管理者等は、本人確認書類を提出する場合、当社が確認に不要と判断する情報（マイナンバー、健康保険証の保険者番号及び被保険者等記号・番号、その他秘匿性の高い情報を含みます。）について、判読不能な状態にマスキングしたうえで提出するものとします。</li>
            <li>当社は、マイナンバーの取得を目的とせず、アカウント管理者等に対して、マイナンバーそのものの提出を求めないものとします。マイナンバーが記載された本人確認書類が提出された場合、当社は、当該番号を本人確認その他本サービスの目的に利用しないものとします。</li>
            <li>当社は、本人確認のため取得した情報について、不正アクセス、漏えい、滅失又は毀損の防止その他安全管理のために必要かつ適切な措置を講じます。また、当該情報については、利用目的の達成後、法令上保存が必要な場合を除き、当社所定の方法により適切に削除又は廃棄するものとします。</li>
          </ol>
        </div>
        <h4>第16条：YouTubeマネタイズサービスについて</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>
              アカウント管理者は、YouTubeマネタイズサービスを利用する場合に、以下のコンテンツをアカウント上に登録又は提供(アップロードを含みます。)してはならないものとします。
              <ol>
                <li>(1) 著作権の保護期間を経過した著作物を含むコンテンツ(クラシック楽曲の音源など)</li>
                <li>(2) 第三者が権利を有する、または第三者からライセンスを受けている音源を含むコンテンツ(サンプリング音源・ライセンス音源など)</li>
                <li>(3) 無償で利用可能な音源を含むコンテンツ(フリー素材、フリートラック、音楽制作ソフトのループ音源素材・サウンドエフェクト音源素材など)</li>
                <li>(4) オリジナル楽曲と差異のないカバー楽曲(有名アーティストの歌真似など)</li>
                <li>(5) オリジナル楽曲のカラオケ、アカペラ、インスト、ショート、リマスター、ライブバージョンなどを収録した楽曲</li>
                <li>(6) オリジナル盤以外のアルバム(コンピレーション盤・リマスター盤・ベスト盤・DJミックス盤など)</li>
                <li>(7) 30秒未満の楽曲</li>
                <li>(8) 音楽以外のポッドキャスト、スピーチ、インタビュー、朗読などのコンテンツ</li>
                <li>(9) 音の識別が難しい楽曲(自然環境音、アンビエント、ヨガ、スリープに部類される楽曲など)</li>
                <li>(10) 当社以外のサービスからYouTubeマネタイズサービスへ登録されたことがある楽曲</li>
              </ol>
            </li>
            <li>アカウント管理者は、YouTubeマネタイズサービスを利用している場合において、第三者の著作権を侵害する動画に、本サービスに登録又は提供(アップロードを含む)したコンテンツを組み合わせてYouTubeにアップロードしてはならないものとします。</li>
            <li>YouTubeマネタイズサービスの利用に関し、第三者からクレームがあった場合には、アカウント管理者自らが対応するものとし、当社は一切関与しないものとします。</li>
          </ol>
        </div>
        <h4>第17条：権利義務の譲渡の禁止</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>アカウント管理者等は、本利用規約上のアカウント管理者等たる地位、本利用規約及び本サービスに関する全ての権利及び義務を、全部か一部かを問わず、第三者に譲渡し又は担保に供する等してはならないものとします。</li>
          </ol>
        </div>
        <h4>第18条：規約の変更</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>本利用規約は、当社の判断により事前の通知なく随時変更を行うことができるものとします。</li>
            <li>本利用規約を変更する場合、当社はその旨を変更後の規約の内容及び変更の効力発生日とともに、本サービスに係る当社所定のウェブサイト上に掲示し、又はアカウント管理者等に通知するものとします。アカウント管理者等はかかる掲示ないし通知を定期的に確認するものとします。</li>
            <li>本利用規約の変更後に、本サービスを利用することにより、アカウント管理者等は変更後の利用規約の全ての記載内容を承諾したものとみなされます。</li>
          </ol>
        </div>
        <h4>第19条：分離可能性</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>本利用規約のいずれかの条項またはその一部が、法令等により無効または執行不能と判断された場合であっても、本利用規約の規定及び一部が無効または執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。</li>
          </ol>
        </div>
        <h4>第20条：準拠法・管轄裁判所</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>本利用規約は日本法に基づいて解釈されるものとします。</li>
            <li>本サービス及び本利用規約に起因し、または関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
          </ol>
        </div>
        <p>本利用規約は2026年6月9日より実施します。</p>
        <p>2026年6月9日改訂</p>
        <div class="c-btn-wrap">
          <router-link
            :to="{ name: 'index' }"
            class="c-btn c-btn--back">
            トップへ戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <!-- eslint-enable max-len -->
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'Terms',
  components: { HeaderBar },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
}
</script>

<style lang="scss" scoped>
  ol.numbered{
    margin-left: 1.2em;
    & > li{
    list-style: decimal;
      }
  }
</style>
